import { Box, Typography, Card, CardContent } from "@mui/material";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { SortableTable } from "../components/SortableTable";
import { baseChartOptions } from "../components/chartBase";
import { useData } from "../context/DataContext";

export default function UsageTrend() {
  const dashboardData = useData();
  const { trendData } = dashboardData;

  const options = {
    ...baseChartOptions,
    chart: { ...baseChartOptions.chart, type: "line", height: 450 },
    xAxis: { categories: trendData.map(d => d.label) },
    yAxis: [
      { title: { text: "GB" } },
      { title: { text: "Users" }, opposite: true },
    ],
    tooltip: { shared: true, valueDecimals: 2 },
    legend: { enabled: true },
    series: [
      { name: "Total WAN", data: trendData.map(d => d.totalWAN), color: "#111", yAxis: 0, lineWidth: 3 },
      { name: "Auth Usage", data: trendData.map(d => d.authUsage), color: "#2f2282", yAxis: 0 },
      { name: "Static Devices", data: trendData.map(d => d.staticUsage), color: "#3dab97", yAxis: 0 },
      { name: "Unauthorized", data: trendData.map(d => d.unauthUsage), color: "#d9534f", yAxis: 0 },
      { name: "Captive Users", data: trendData.map(d => d.captiveUsers), color: "#e8a33d", yAxis: 1, dashStyle: "ShortDash" },
    ],
  };

  const columns = [
    { key: "date", header: "Date", cell: (row: any) => row.label },
    { key: "totalWAN", header: "Total WAN (GB)", align: "right" as const, sortable: true, sortFn: (a: any, b: any) => a.totalWAN - b.totalWAN, cell: (row: any) => <Box sx={{ fontFamily: "monospace" }}>{row.totalWAN.toFixed(2)}</Box> },
    { key: "authUsage", header: "Auth (GB)", align: "right" as const, sortable: true, sortFn: (a: any, b: any) => a.authUsage - b.authUsage, cell: (row: any) => <Box sx={{ fontFamily: "monospace", color: "#2f2282" }}>{row.authUsage.toFixed(2)}</Box> },
    { key: "staticUsage", header: "Static (GB)", align: "right" as const, sortable: true, sortFn: (a: any, b: any) => a.staticUsage - b.staticUsage, cell: (row: any) => <Box sx={{ fontFamily: "monospace", color: "#3dab97" }}>{row.staticUsage.toFixed(2)}</Box> },
    { key: "unauthUsage", header: "UnAuth (GB)", align: "right" as const, sortable: true, sortFn: (a: any, b: any) => a.unauthUsage - b.unauthUsage, cell: (row: any) => <Box sx={{ fontFamily: "monospace", color: "#d9534f" }}>{row.unauthUsage.toFixed(2)}</Box> },
    { key: "captiveUsers", header: "Users", align: "right" as const, sortable: true, sortFn: (a: any, b: any) => a.captiveUsers - b.captiveUsers, cell: (row: any) => <Box sx={{ fontFamily: "monospace", color: "#e8a33d" }}>{row.captiveUsers}</Box> },
    { key: "authPerUser", header: "Auth/User (GB)", align: "right" as const, sortable: true, sortFn: (a: any, b: any) => a.authPerUser - b.authPerUser, cell: (row: any) => <Box sx={{ fontFamily: "monospace" }}>{row.authPerUser.toFixed(2)}</Box> },
  ];

  return (
    <Box sx={{ p: 2 }}>
      <Box mb={2}>
        <Typography variant="subtitle1" fontWeight={600}>Usage Trend</Typography>
        <Typography variant="body2" color="text.secondary">Multi-metric correlation analysis over time</Typography>
      </Box>

      <Card variant="outlined" sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant="subtitle1" fontWeight={600}>Fleet Consumption Timeline</Typography>
          <Typography variant="caption" color="text.secondary">Primary metrics in GB (left axis), user count (right axis)</Typography>
          <HighchartsReact highcharts={Highcharts} options={options} />
        </CardContent>
      </Card>

      <Typography variant="subtitle1" fontWeight={600} mb={1}>Daily Breakdown</Typography>
      <SortableTable data={trendData} columns={columns} defaultSortKey="totalWAN" defaultSortOrder="desc" />
    </Box>
  );
}
